/* eslint-disable prettier/prettier */
export class Config {
    static apiUrl = "https://api.excelsync.com/";
    static connectionString = '';
    static limit = 10000;
    static databaseType = 'MSSQL';
}
